import type { ContentItem } from "@/types/content";
import { TYPE_LABEL } from "@/types/content";

export default function DetailBanner({ item }: { item: ContentItem }) {
  return (
    <section className="relative rounded-lg overflow-hidden h-[320px] md:h-[440px] bg-foreground-950">
      <img
        src={item.cover}
        alt={item.title}
        title={`${item.title} 影视工厂`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/60 to-foreground-950/25" />
      <div className="relative h-full flex flex-col justify-end p-5 md:p-10">
        <div>
          <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs">
            {TYPE_LABEL[item.type]}
          </span>
          <h1 className="mt-3 font-heading text-3xl md:text-5xl text-background-50 tracking-wide">
            {item.title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-background-200">
            {typeof item.rating === "number" && (
              <span className="flex items-center gap-1 text-accent-400 font-medium">
                <i className="ri-star-fill" />
                {item.rating.toFixed(1)}
              </span>
            )}
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              {item.year}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-map-pin-line" />
              {item.region}
            </span>
            {(item.duration || item.episodes) && (
              <span className="flex items-center gap-1">
                <i className="ri-time-line" />
                {item.duration ? item.duration : `全 ${item.episodes} 集`}
              </span>
            )}
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {item.genres.map((genre) => (
              <span
                key={genre}
                className="px-2.5 py-1 rounded-md bg-background-50/15 text-background-100 text-xs"
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}